export const REFRESH_MENU_ITEMS_ACTION = 'PANEL_MENU.REFRESH_MENU_ITEMS_ACTION';
export const PANEL_MENU_ITEM_SET_ACTIVE_ACTION = 'PANEL_MENU.PANEL_MENU_ITEM_SET_ACTIVE_ACTION';
